export const ALLOWED_IMAGE_TYPES = new Set([
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "application/pdf",
    "application/postscript",
]);

const ALLOWED_IMAGE_EXTENSIONS = new Set([".jpg", ".jpeg", ".png", ".svg", ".pdf", ".ps", ".eps"]);

export function isAllowedImageType(mimeType, fileName = "") {
    if (ALLOWED_IMAGE_TYPES.has(mimeType)) {
        return true;
    }

    const normalizedName = String(fileName || "").toLowerCase();
    return Array.from(ALLOWED_IMAGE_EXTENSIONS).some((extension) => normalizedName.endsWith(extension));
}

export function dispatchFigureModalPasteEvent(imageData) {
    window.dispatchEvent(
        new CustomEvent("figure-modal:paste-image", {
            detail: imageData,
        }),
    );
}

export async function findImageInClipboard() {
    try {
        const clipboardItems = await navigator.clipboard.read();

        for (const item of clipboardItems) {
            for (const type of item.types) {
                if (isAllowedImageType(type)) {
                    const blob = await item.getType(type);
                    return new File([blob], `image.${type.split("/")[1]}`, {
                        type,
                    });
                }
            }
        }
    } catch (_error) {
        return null;
    }

    return null;
}

export async function handleImagePaste() {
    const imageFile = await findImageInClipboard();
    if (imageFile) {
        dispatchFigureModalPasteEvent({
            name: imageFile.name,
            type: imageFile.type,
            data: imageFile,
        });
        return true;
    }
    return false;
}
